import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";

const VideoTutorialIcon = (props) => (
  <Svg
    width={20}
    height={20}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <G clipPath="url(#a)" fill={props.color}>
      <Path d="M17.844 5.556H2.156A1.044 1.044 0 0 0 1.11 6.6v10.133a1.045 1.045 0 0 0 1.045 1.045h15.688a1.045 1.045 0 0 0 1.045-1.045V6.6a1.044 1.044 0 0 0-1.045-1.044Zm-.066 11.11H2.222v-10h15.556v10ZM16.744 1.667a.555.555 0 0 0-.555-.556H3.967a.556.556 0 0 0-.556.556v.555h13.333v-.555ZM17.845 3.889a.556.556 0 0 0-.556-.556H2.844a.556.556 0 0 0-.555.556v.555h15.555V3.89Z" />
      <Path d="M7.122 14.883a.933.933 0 0 0 .9.072l5.428-2.422a.94.94 0 0 0 0-1.722L8.022 8.39a.944.944 0 0 0-1.328.861v4.845a.945.945 0 0 0 .428.788Zm.35-5.633a.161.161 0 0 1 .078-.139.167.167 0 0 1 .089 0 .15.15 0 0 1 .067 0l5.427 2.417a.161.161 0 0 1 .1.155.155.155 0 0 1-.1.15l-5.427 2.423a.156.156 0 0 1-.156 0 .173.173 0 0 1-.078-.14V9.25Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h20v20H0z" />
      </ClipPath>
    </Defs>
  </Svg>
);
VideoTutorialIcon.defaultProps = {
  color: "#716C6C",
};
export default VideoTutorialIcon;
